import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
//import { ViewEncapsulation } from '@angular/compiler/src/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, BrowserUtils, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ApplicationControlService } from '../../services/applicationcontrol.service'
import { AuthService } from '../../services/auth.service'
//import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrl: '../../styles.css',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    public isIframe: boolean = true;
    public isExpanded: boolean = true;
    public loggedIn: boolean = false;
    //public subscription: Subscription | undefined;
    private readonly _destroying$ = new Subject<void>();
    //private location: Location = {} as Location;

    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private msalService: MsalService,
        private applicationControlService: ApplicationControlService,
        private authService: AuthService,
        private msalBroadcastService: MsalBroadcastService,
        private location: Location
    ) {
        //this.loggedIn = this.msalService.getUser() != null;
        //this.loggedIn = this.msalService.getAccount() != null;
        //this.loggedIn = this.msalService.instance.getActiveAccount() != null;
        //console.log("app.component:constructor", this.loggedIn);
        this.applicationControlService.getApplicationControlsByAppName("CacheControlVersion", false).subscribe(result => {
            if (result.length > 0) {
                var cacheVersion = result[0].appSettingValue;
                var browserCacheVersion = localStorage.getItem("CacheControlVersion");
                if (cacheVersion != browserCacheVersion) {
                    // Clear cached items and update the CacheControlVersion
                    Object.keys(localStorage).forEach(function (key) {
                        //var item = localStorage.getItem(key);
                        if (key.startsWith("ApplicationControl")) {
                            localStorage.removeItem(key);
                        }
                    });
                    localStorage.setItem("CacheControlVersion", cacheVersion);
                }
                console.log("CacheControlVersion", cacheVersion, browserCacheVersion);
            }
        });
    }

    ngOnInit(): void {
        const currentPath = this.location.path();

        // Dont perform nav if in iframe or popup, other than for front-channel logout
        this.isIframe = BrowserUtils.isInIframe() && !window.opener && currentPath.indexOf("logout") < 0;
        this.setLoginDisplay();

        //this.broadcastService.subscribe("msal:loginSuccess", (payload) => {
        //    //console.log("login success " + JSON.stringify(payload));
        //    this.loggedIn = true;
        //});

        //this.subscription = this.broadcastService.subscribe("msal:acquireTokenFailure", (payload) => {
        //    console.log('acquire token failure' + JSON.stringify(payload));
        //});

        this.msalBroadcastService.msalSubject$
            .pipe(
                filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
                takeUntil(this._destroying$)
            )
            .subscribe((result: EventMessage) => {
                //console.log("app.component:ngOnInit:msalBroadcastService.msalSubject$", result, currentPath, this.isIframe);
                const payload = result.payload as AuthenticationResult;
                //this.msalService.instance.setActiveAccount(payload.account);
                this.authService.handleToken(payload);

                //this.setLoginDisplay();
                //this.checkAndSetActiveAccount();
            });

        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            )
            .subscribe(() => {
                //console.log("app.component:ngOnInit:msalBroadcastService.inProgress$", currentPath, this.isIframe);
                this.setLoginDisplay();
                this.checkAndSetActiveAccount();
                this.authService.setLocalStorage();
            });

        //this.subscription = this.broadcastService.subscribe("msal:acquireTokenFailure", (payload) => {
        //    console.log('acquire token failure' + JSON.stringify(payload));
        //});
    }

    private setLoginDisplay() {
        this.loggedIn = this.msalService.instance.getAllAccounts().length > 0;
        //console.log("app.component:setLoginDisplay", this.loggedIn, this.msalService.instance.getAllAccounts());
    }

    private checkAndSetActiveAccount() {
        /**
         * If no active account set but there are accounts signed in, sets first account to active account
         * To use active account set here, subscribe to inProgress$ first in your component
         * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
         */
        let activeAccount = this.msalService.instance.getActiveAccount();
        //console.log("app.component:checkAndSetActiveAccount", activeAccount);

        if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
            let accounts = this.msalService.instance.getAllAccounts();
            this.msalService.instance.setActiveAccount(accounts[0]);
            //console.log("app.component:checkAndSetActiveAccount", activeAccount, accounts);
        }

        this.handleCallback();
    }

    private handleCallback() {
        // Found here:
        // https://stackoverflow.com/questions/66405214/browserautherror-interaction-in-progress-interaction-is-currently-in-progress
        // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/events.md
        //const msalInstance = new PublicClientApplication(msalConfig);
        //msalInstance.addEventCallback((event) => {
        //    // set active account after redirect
        //    if (event.payload && event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        //        const account = event.payload.account;
        //        msalInstance.setActiveAccount(account);
        //    }
        //}, error => {
        //    console.log('error', error);
        //});

        //console.log('get active account', msalInstance.getActiveAccount());

        //// handle auth redired/do all initial setup for msal
        //msalInstance.handleRedirectPromise().then(authResult => {
        //    // Check if user signed in 
        //    const account = msalInstance.getActiveAccount();
        //    if (!account) {
        //        // redirect anonymous user to login page 
        //        msalInstance.loginRedirect();
        //    }
        //}).catch(err => {
        //    // TODO: Handle errors
        //    console.log(err);
        //});
    }

    public toggleContainer() {
        this.isExpanded = !this.isExpanded;
    }

    ngOnDestroy(): void {
        //this.broadcastService.getMSALSubject().next(1);
        //if (this.subscription) {
        //    this.subscription.unsubscribe();
        //}
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }
}
